import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import { Box, Button, Chip, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';

interface RoomPolicyListEditorProps {
  title: string;
  items: Array<string>;
  onChange: (items: Array<string>) => void;
  firstItemLocked?: boolean;
  firstItemLabel?: string;
}

export default function RoomPolicyListEditor({
  title,
  items,
  onChange,
  firstItemLocked = false,
  firstItemLabel,
}: RoomPolicyListEditorProps) {
  const handleItemChange = (index: number, value: string) => {
    const updatedItems = [...items];
    updatedItems[index] = value;
    onChange(updatedItems);
  };

  const handleAddItem = () => {
    onChange([...items, '']);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = items.filter((_, i) => i !== index);
    onChange(updatedItems);
  };

  const isLocked = (index: number) => firstItemLocked && index === 0;

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Stack spacing={1}>
        {items.map((item, index) => (
          <Stack key={index} direction="row" spacing={1} alignItems="center">
            <TextField
              fullWidth
              size="small"
              value={item}
              onChange={(e) => handleItemChange(index, e.target.value)}
              disabled={isLocked(index)}
            />
            {isLocked(index) ? (
              <>
                {firstItemLabel && (
                  <Chip
                    icon={<LockIcon fontSize="small" />}
                    label={firstItemLabel}
                    size="small"
                    color="default"
                    variant="outlined"
                    sx={{ whiteSpace: 'nowrap' }}
                  />
                )}
                <Tooltip title="This is the room default and cannot be removed">
                  <span>
                    <IconButton size="small" disabled>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </>
            ) : (
              <IconButton size="small" onClick={() => handleRemoveItem(index)} color="error">
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        ))}
      </Stack>
      <Button size="small" startIcon={<AddIcon />} onClick={handleAddItem} sx={{ mt: 1 }}>
        Add item
      </Button>
    </Box>
  );
}
